import { Pipe, PipeTransform } from '@angular/core';
import { AssetService, AssetType } from './asset.service';

@Pipe({
  name: 'rdAssetPath',
})
export class AssetPathPipe implements PipeTransform {
  constructor(private assetService: AssetService) {}

  transform(name: string, type: AssetType): string {
    return this.assetService.getAssetPath(name, type);
  }
}
